import Cookies from 'js-cookie';
import _ from 'lodash';
import {
    setInitialState,
    addCustomImage,
    setMinOrderAmount,
    showNotification,
    hideNotification,
    openNoticePopup,
    setNoticePopupContent,
} from '../actionCreators/configurator';
import { toggleVisibility as toggleIntroductionLayer } from '../actionCreators/introductionLayer';
import API from '../../API';
import { applyBrownFilterToImage } from '../../helpers/imageHelpers';
import { convertConfigToSnakeCase } from '../../helpers/generalHelpers';
import { getText } from '../../helpers/translationHelper';
import settings from '../../settings';

/*
global b4w
*/

export function initScene(slug) {
    const lib3d = b4w.require('Library3D');
    return () => {
        return new Promise((resolve, reject) => {
            lib3d.init(slug, resolve, () => {
            });
        });
    };
}

export function onImageUpload(event) {
    return dispatch => {
        const input = event.target;
        const file = input.files[0];
        const reader = new FileReader();
        input.value = null;

        if (!file) {
            return;
        }

        return new Promise((resolve, reject) => {
            reader.addEventListener(
                'load',
                () => {
                    // load image to get its width and height
                    const o = new Image();
                    o.src = reader.result;
                    return (o.onload = () => {
                        const image = {
                            id: Date.now(),
                            width: o.width,
                            height: o.height,
                            src: reader.result, // base64 encoded image
                        };
                        applyBrownFilterToImage(image).then(filteredImage => {
                            image.filteredSrc = filteredImage.src;
                            dispatch(addCustomImage(image));
                            resolve(image);
                        });
                    });
                },
                false,
            );
            reader.readAsDataURL(file);
        });
    };
}

export function fetchPenData(slug) {
    return dispatch => {
        return API.getPenBySlug(slug).then(response => {
            return new Promise((resolve, reject) => {
                if (response.status === 200 && response.data) {
                    const pen = response.data.data;
                    const localConfig = JSON.parse(localStorage.getItem(slug));
                    const initialState = {
                        penId: pen.id,
                        penName: pen.name,
                        penSlug: pen.slug,
                        isLoading: true,
                        defaultTemplate: pen.default_template,
                        initialConfig: {
                            parts: pen.templates[pen.default_template].parts,
                            template: pen.default_template,
                            printableAreas: {},
                            engravingAreas: {},
                            mine: {},
                            mine_color: pen.templates[pen.default_template].mine_color
                        },
                        parts: pen.configurables.parts,
                        printableAreas: pen.configurables.printable_areas,
                        engravingAreas: pen.configurables.engraving_areas,
                        templates: pen.templates,
                        mine: {},
                        activeMineColor: pen.templates[pen.default_template].mine_color,
                    };

                    if (pen.configurables.mine) {
                        initialState.mine = {
                            colors: pen.configurables.mine.colors,
                        };
                    }

                    // pen has mine not just writing colors
                    if (pen.mine) {
                        initialState.activeMine = pen.mine.id;
                        initialState.mine = { ...initialState.mine, ...pen.mine };
                    }

                    // set localConfig as config if there is one
                    initialState.config = localConfig ? localConfig : _.cloneDeep(initialState.initialConfig);

                    dispatch(setInitialState(initialState));
                    resolve(initialState.config);
                } else {
                    // TODO redirect to error page
                    reject({ message: response.error });
                }
            });
        });
    };
}

export function showIntroductionLayerOnFirstVisit() {
    return dispatch => {
        const cookieName = 'has-seen-introduction-layer';
        if (Cookies.get(cookieName)) {
            return;
        }

        Cookies.set(cookieName, true, { expires: 365 });
        dispatch(toggleIntroductionLayer());
    };
}

export function minimumOrderMiddleware(slug, config) {
    const formatedConfig = convertConfigToSnakeCase(config);
    return dispatch => {
        API.getMinimumOrderAmountForConfiguration(slug, formatedConfig).then(res => {
            const minAmount = res.data.min_amount;

            // return if minAmount equals current minAmount
            if (minAmount === config.minOrderAmount) {
                return;
            }

            dispatch(setMinOrderAmount(minAmount));
            dispatch(showNotification());

            // hide minimum order amount notice after 3.5s
            setTimeout(() => dispatch(hideNotification()), 3500);
        });
    };
}

export function areaSelectMiddleware(penSlug, areaName) {
    return dispatch => {
        const { pensWithSingleColorAreas } = settings.configurator;

        // return if pen has no single color areas
        if (!pensWithSingleColorAreas.hasOwnProperty(penSlug)) {
            return;
        }

        const singleColorAreas = pensWithSingleColorAreas[penSlug];

        // return if area is not a single color area
        if (!singleColorAreas.includes(areaName)) {
            return;
        }

        dispatch(
            setNoticePopupContent(
                getText('single.color.area.notice.popup.title'),
                getText('single.color.area.notice.popup.text'),
                getText('single.color.area.notice.popup.button.label'),
            ),
        );

        dispatch(openNoticePopup());
    };
}
